export default "__VITE_ASSET__D0ji72JL__"